import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { Box, FormControlLabel, Switch } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import axios from "helpers/API";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import { errorBackendMsg } from "helpers/helpers";
import TablaMaterialUI from "componentes/TablaMaterialUI";

function BandaHorariaLista({
    drawer,
    parametrosEdit,
    recargarTabla,
    setRecargarTabla,
}) {
    const [parametros, setParametros] = useState([]);
    const [filtroActivas, setFiltroActivas] = useState(true);
    const [cargandoLista, setCargandoLista] = useState(true);
    // MODALS
    const [modalExito, setModalExito] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [msgError, setMsgError] = useState("");
    const [msgExito, setMsgExito] = useState("");

    const [idBorrar, setIdBorrar] = useState(null);
    const [modalBorrar, setModalBorrar] = useState(false);

    // API Mensaje
    const [mensajeError, setMensajeError] = useState("");
    const [showError, setShowError] = useState(false);

    const mostrarModalBorrar = (id) => {
        setIdBorrar(id);
        setModalBorrar(true);
    };

    useEffect(() => {
        consultarParametros(filtroActivas);
    }, [filtroActivas]);

    React.useEffect(() => {
        if (recargarTabla) {
            consultarParametros(filtroActivas);
            setRecargarTabla(false);
        }
    }, [recargarTabla]);

    const peticionBase = ({
        url,
        dataRequest = {},
        hook = false,
        errorHook = false,
    }) => {
        axios
            .post(url, dataRequest)
            .then(function (response) {
                if (response.data.error) {
                    if (Boolean(errorHook)) {
                        errorHook(response.data);
                    } else {
                        setShowError(true);
                        setMensajeError(response.data.msg);
                    }
                } else {
                    if (Boolean(hook)) {
                        hook(response.data);
                    }
                }
            })
            .catch(function (error) {
                setMensajeError(errorBackendMsg(error));
            });
    };

    const consultarParametros = (filtroActivas) => {
        const hook = (data) => {
            setParametros(data);
            setCargandoLista(false);
        };
        let peticion = {
            url: "/generales/parametros/listar",
            hook: hook,
            dataRequest: { activado: filtroActivas },
        };
        peticionBase(peticion);
    };

    const borrarBanda = () => {
        const hook = () => {
            consultarParametros(filtroActivas);
            setModalExito(true);
            setMsgExito("La Banda Horaria se ha borrado correctamente");
        };
        const errorHook = (data) => {
            setModalError(true);
            setMsgError(data.msg);
        };
        let peticion = {
            url: "/parametros/eliminar",
            hook: hook,
            errorHook: errorHook,
            dataRequest: { id: idBorrar },
        };
        peticionBase(peticion);
    };

    const editarParametros = (parametro) => {
        const hook = (data) => {
            console.log("ver data", data);
            parametrosEdit(data);
            drawer(true);
        };
        let peticion = {
            url: "/generales/parametros/obtener",
            hook: hook,
            dataRequest: { id: parametro.id },
        };
        peticionBase(peticion);
    };

    const columns = [
        {
            field: "id",
            hide: true,
        },
        {
            field: "nombreAbreviado",
            headerName: "Parámetro",
            flex: 0.7,
        },
        {
            field: "auxCadena1",
            headerName: "String 1",
            flex: 0.7,
        },
        {
            field: "auxCadena2",
            headerName: "String 2",
            flex: 0.7,
        },
        {
            field: "auxEntero1",
            headerName: "Int 1",
            flex: 0.4,
        },
        {
            field: "auxEntero2",
            headerName: "Int 2",
            flex: 0.4,
        },
        {
            field: "auxFecha1",
            headerName: "Date 1",
            flex: 0.4,
        },
        {
            field: "auxFecha2",
            headerName: "Date 2",
            flex: 0.4,
        },
        {
            headerName: "Acciones",
            field: "acciones",
            renderCell: (data) => (
                <strong>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginLeft: 16 }}
                        onClick={() => editarParametros(data.row)}
                    >
                        Editar
                    </Button>
                </strong>
            ),
        },
    ];

    return (
        <>
            <Grid item md={12}>
                <APIMensajeMUI
                    mb={30}
                    tipo="error"
                    showMensaje={showError}
                    msg={mensajeError}
                />
                <Card>
                    <Box mt={1}>
                        <FormControlLabel
                            labelPlacement="start"
                            control={
                                <Switch
                                    checked={filtroActivas}
                                    onChange={() =>
                                        setFiltroActivas(!filtroActivas)
                                    }
                                />
                            }
                            label="Activas"
                        />
                    </Box>
                    {modalBorrar && (
                        <MsgConfirmacion
                            setVisible={setModalBorrar}
                            titulo="Borrar Banda"
                            msg={"¿Desea borrar la banda seleccionada?"}
                            aceptar={borrarBanda}
                        />
                    )}
                    {modalError && (
                        <MsgGenericoAlerta
                            setVisible={setModalError}
                            titulo="Error"
                            msg={msgError}
                        />
                    )}
                    {modalExito && (
                        <MsgGenericoAlerta
                            setVisible={setModalExito}
                            titulo="Borrar Banda"
                            msg={msgExito}
                        />
                    )}
                    <div style={{ height: 400, width: "100%" }}>
                        <TablaMaterialUI
                            columnas={columns}
                            filas={parametros}
                            sortModel={{
                                field: "id",
                                sort: "desc",
                            }}
                            cargando={cargandoLista}
                        />
                    </div>
                </Card>
            </Grid>
        </>
    );
}
export default BandaHorariaLista;
